import { useCallback, useMemo } from 'react'

export const hookGlobalPermanentLinkFactory = () => ({ fetch }) => {
  const create = useCallback((configuration, days) => fetch({
    method: 'post',
    url: 'permanent-link',
    data: { configuration, days },
  }), [fetch])

  const load = useCallback(id => fetch({ url: `permanent-link/${id}` }), [fetch])

  return useMemo(() => ({
    permanentLink: { create, load },
  }), [create, load])
}
